"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoState = void 0;
const toolbox_1 = require("@streem/toolbox");
const operators_1 = require("rxjs/operators");
const observable_map_1 = require("../../../util/observable_map");
const utils_1 = require("../../wall/utils");
const connected_strategy_1 = require("../video_controller/connected_strategy");
const video_controllers_1 = require("../video_controller/video_controllers");
class VideoState extends observable_map_1.ObservableMap {
    constructor(config) {
        super();
        this.config = config;
        this.localController = this.values.pipe((0, operators_1.map)((cs) => cs.find((c) => c.ownerIsLocalUser)));
    }
    removeVideoController(controller) {
        controller.destroy();
    }
    createNewController(args) {
        (0, toolbox_1.invariant)(this.config.context.callSettings, 'Expected callSettings to be defined when creating a new controller');
        (0, toolbox_1.invariant)(this.config.context.localUserId, 'Expected localUserId to be defined when creating a new controller');
        if (!this.has(args.wallItemId)) {
            const isLocalUser = args.ownerUserId.compare(this.config.context.localUserId);
            const track = this.findVideoTrack(isLocalUser);
            const wallItem = this.findWallItem(args.wallItemId);
            const controller = new video_controllers_1.VideoController({
                id: args.wallItemId,
                roomWall: this.config.roomWall,
                roomId: this.config.context.roomId,
                track,
                wallItem,
                owner: {
                    id: args.ownerUserId,
                    isLocalUser,
                },
                onDestroy: (controller) => void this.delete(controller.id),
            });
            /**
             * If the VideoTrack WallItem does not have a `name`, then we
             * are Streeming with an old iOS / Android App. This app
             * will not support 2WV.
             */
            if (!args.videoTrackName || !this.config.trackProvider.useNamedVideoTracks) {
                controller.setConnectedStrategy(new connected_strategy_1.DefaultConnectedStrategy(track));
            }
            else {
                controller.setConnectedStrategy(new connected_strategy_1.NameConnectedStrategy(wallItem, track));
            }
            controller.connect();
            this.set(args.wallItemId, controller);
        }
    }
    clearState() {
        this.forEach(this.removeVideoController);
    }
    findVideoTrack(isLocalUser) {
        return (isLocalUser
            ? this.config.trackProvider.localVideoTrack
            : this.config.trackProvider.remoteVideoTrack).pipe((0, operators_1.distinctUntilChanged)(), (0, operators_1.shareReplay)(1));
    }
    findWallItem(id) {
        return this.config.roomWall.itemsById.pipe((0, utils_1.findInGroup)(id), (0, utils_1.mapWallItemFromWallItemEvents)('videoTrack'));
    }
}
exports.VideoState = VideoState;
//# sourceMappingURL=video_state.js.map